<template>
  <div class="w-full flex flex-wrap px-4 py-2" v-if="input">
    <div class="w-full text-right">
      <a class="cursor-pointer px-4 py-2" @click="$emit('close')">
        <font-awesome-icon :icon="['fas', 'times']" />
      </a>
    </div>

    <div class="w-full flex">
      <p class="text-xl flex-1">
        <b-checkbox
          v-model="input.display.selected"
          id="display.selected"
          :errors="form.errors"
          @input="form.errors.clear('selected')"
          >Display</b-checkbox
        >
      </p>
    </div>

    <div class="w-full flex flex-wrap" v-if="input.display.selected">
      <div class="w-1/3">
        <b-select
          class="mx-2 mb-1"
          v-model="input.display.type"
          id="display.type"
          label="Type"
          :errors="form.errors"
        >
          <option value="cpm">CPM</option>
          <option value="agency">Agency %</option>
        </b-select>
      </div>

      <div class="w-1/3">
        <b-input
          class="mx-2 mb-1"
          min="0"
          v-model="input.display.percent"
          type="number"
          id="display.percent"
          :label="input.display.type === 'cpm' ? '% for Media' : 'Agency %'"
          :errors="form.errors"
        ></b-input>
      </div>

      <div class="w-1/3" v-show="input.display.type === 'cpm'">
        <b-input
          class="mx-2 mb-1"
          min="0"
          v-model="input.display.cpm"
          type="number"
          id="display.cpm"
          label="CPM"
          :errors="form.errors"
        ></b-input>
      </div>

      <div class="w-full">
        <label class="block mx-2 mb-1">
          <span class="cursor-pointer text-sm">Services</span>
          <b-multiselect
            v-model="input.display.services"
            :options="services.display"
            label="name"
            track-by="slug"
            @input="form.errors.clear('display.services')"
          ></b-multiselect>
        </label>
      </div>

      <div
        class="w-1/3"
        v-for="service in input.display.services"
        :key="service.slug"
      >
        <b-input
          class="mx-2 mb-1"
          min="0"
          max="100"
          v-model="input.display.budgets[service.slug]"
          type="number"
          :id="'display.budget.' + service.slug"
          :label="'Budget for ' + service.name"
          :errors="form.errors"
          @input="form.errors.clear('display')"
        ></b-input>
      </div>

      <div class="w-full" v-if="form.errors.has('display')">
        <p class="text-sm text-red-800 mb-1 mx-2">
          {{ form.errors.first("display") }}
        </p>
      </div>
    </div>

    <div class="w-full flex">
      <p class="text-xl flex-1">
        <b-checkbox
          v-model="input.video.selected"
          id="video.selected"
          :errors="form.errors"
          @input="form.errors.clear('selected')"
          >Video</b-checkbox
        >
      </p>
    </div>

    <div class="w-full flex flex-wrap" v-if="input.video.selected">
      <div class="w-1/3">
        <b-select
          class="mx-2 mb-1"
          v-model="input.video.type"
          id="video.type"
          label="Type"
          :errors="form.errors"
        >
          <option value="cpm">CPM</option>
          <option value="agency">Agency %</option>
        </b-select>
      </div>

      <div class="w-1/3">
        <b-input
          class="mx-2 mb-1"
          min="0"
          v-model="input.video.percent"
          type="number"
          id="video.percent"
          :label="input.video.type === 'cpm' ? '% for Media' : 'Agency %'"
          :errors="form.errors"
        ></b-input>
      </div>

      <div class="w-1/3" v-show="input.video.type === 'cpm'">
        <b-input
          class="mx-2 mb-1"
          min="0"
          v-model="input.video.cpm"
          type="number"
          id="video.cpm"
          label="CPM"
          :errors="form.errors"
        ></b-input>
      </div>

      <div class="w-full">
        <label class="block mx-2 mb-1">
          <span class="cursor-pointer text-sm">Services</span>
          <b-multiselect
            v-model="input.video.services"
            :options="services.video"
            label="name"
            track-by="slug"
            @input="form.errors.clear('video.services')"
          ></b-multiselect>
        </label>
      </div>

      <div
        class="w-1/3"
        v-for="service in input.video.services"
        :key="service.slug"
      >
        <b-input
          class="mx-2 mb-1"
          min="0"
          max="100"
          v-model="input.video.budgets[service.slug]"
          type="number"
          :id="'video.budget.' + service.slug"
          :label="'Budget for ' + service.name"
          :errors="form.errors"
          @input="form.errors.clear('video')"
        ></b-input>
      </div>

      <div class="w-full" v-if="form.errors.has('video')">
        <p class="text-sm text-red-800 mb-1 mx-2">
          {{ form.errors.first("video") }}
        </p>
      </div>
    </div>

    <div class="w-full flex">
      <p class="text-xl flex-1">
        <b-checkbox
          v-model="input.sem.selected"
          id="sem.selected"
          :errors="form.errors"
          @input="form.errors.clear('selected')"
          >SEM</b-checkbox
        >
      </p>
    </div>

    <div class="w-full flex flex-wrap" v-if="input.sem.selected">
      <div class="w-1/2">
        <b-input
          class="mx-2 mb-1"
          min="0"
          max="100"
          v-model="input.sem.percent"
          type="number"
          id="sem.percent"
          label="Agency %"
          :errors="form.errors"
        ></b-input>
      </div>

      <div class="w-1/2">
        <label class="block mx-2 mb-1">
          <span class="cursor-pointer text-sm">Services</span>
          <b-multiselect
            v-model="input.sem.services"
            :options="services.sem"
            label="name"
            track-by="slug"
            @input="form.errors.clear('sem.services')"
          ></b-multiselect>
        </label>
      </div>

      <div
        class="w-1/2"
        v-for="service in input.sem.services"
        :key="service.slug"
      >
        <b-input
          class="mx-2 mb-1"
          min="0"
          max="100"
          v-model="input.sem.budgets[service.slug]"
          type="number"
          :id="'sem.budget.' + service.slug"
          :label="'Budget for ' + service.name"
          :errors="form.errors"
          @input="form.errors.clear('sem')"
        ></b-input>
      </div>

      <div class="w-full" v-if="form.errors.has('sem')">
        <p class="text-sm text-red-800 mb-1 mx-2">
          {{ form.errors.first("sem") }}
        </p>
      </div>
    </div>

    <div class="w-full" v-if="form.errors.has('selected')">
      <p class="text-sm text-red-800 mb-1 mx-2">
        {{ form.errors.first("selected") }}
      </p>
    </div>

    <div class="w-full mt-2">
      <b-button @click="submit">Submit</b-button>
    </div>
  </div>
</template>

<script>
import { EventBus } from "../events"
import { map, cloneDeep, merge, find } from "lodash"
import Form from "form-backend-validation"
import FormMixin from "@/components/FormMixin"

export default {
  name: "UpdatePeriodForm",
  mixins: [FormMixin],
  props: {
    companies: {
      required: true,
    },
    existing: {
      required: true,
    },
  },
  data() {
    return {
      form: new Form(),
      input: null,
    }
  },
  methods: {
    async submit() {
      EventBus.$emit("loading:start")

      let data = {}

      if (this.input.display.selected) {
        data.display = cloneDeep(this.input.display)
        data.display.services = map(data.display.services, "slug")
      } else {
        data.display = null
      }

      if (this.input.video.selected) {
        data.video = cloneDeep(this.input.video)
        data.video.services = map(data.video.services, "slug")
      } else {
        data.video = null
      }

      if (this.input.sem.selected) {
        data.sem = cloneDeep(this.input.sem)
        data.sem.services = map(data.sem.services, "slug")
      } else {
        data.sem = null
      }

      await this.axios
        .post("budget/period/update/" + this.existing.id, data)
        .then(() => {
          this.$emit("close")
          EventBus.$emit("fetch-items")
        })
        .catch((resp) => {
          if (resp.response && resp.response.status === 422) {
            this.form.onFail(resp)
          }
        })

      EventBus.$emit("loading:stop")
    },
  },
  created() {
    let data = {}

    if (this.existing.display !== null) {
      data.display = merge(cloneDeep(this.existing.display), { selected: true })
      data.display.services = map(data.display.services, (item) => {
        return find(this.services.display, { slug: item })
      })
    } else {
      data.display = cloneDeep(this.defaults.display)
    }

    if (this.existing.video !== null) {
      data.video = merge(cloneDeep(this.existing.video), { selected: true })
      data.video.services = map(data.video.services, (item) => {
        return find(this.services.video, { slug: item })
      })
    } else {
      data.video = cloneDeep(this.defaults.video)
    }

    if (this.existing.sem !== null) {
      data.sem = cloneDeep(this.existing.sem)
      data.sem.selected = true
      data.sem.services = map(data.sem.services, (item) => {
        return find(this.services.sem, { slug: item })
      })
    } else {
      data.sem = cloneDeep(this.defaults.sem)
    }

    this.input = data
  },
}
</script>

<style lang="scss" scoped>
</style>
